import { HAND_COMBINATIONS_LABELS } from '@lbs/shared-rp-types'
import { Button, List, ListItem } from '@mui/material'
import { MaterialReactTable, MRT_ColumnDef, MRT_PaginationState, useMaterialReactTable } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import mrtLocalization from '../../constants/mrtLocalization'
import { Prp2boxApiPayouts } from '../../prp2boxApi'
import { IRpPayout } from '../../prp2boxApi/payouts'
import { useStore } from '../../stores'
import { EDrawerView } from '../../stores/DrawerCRUD.store'
import { formatToMoscowTZ } from '../../utils/date'
import { Item } from './styles'

const columns: MRT_ColumnDef<IRpPayout>[] = [
  {
    accessorKey: 'name',
    header: 'Имя',
  },
  {
    header: 'Выплаты',
    Cell: ({ row }) => {
      return (
        <List dense>
          {row.original.data
            .sort((a, b) => b.multiplier - a.multiplier)
            .map((rowItem, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <ListItem key={index} disablePadding>
                  <Item>
                    <span>{HAND_COMBINATIONS_LABELS.ru[rowItem.combination]}</span>
                    <span>{rowItem.multiplier}:1</span>
                  </Item>
                </ListItem>
              )
            })}
        </List>
      )
    },
  },
  {
    accessorKey: 'updatedAt',
    header: 'Последнее обновление',
    sortingFn: 'datetime',
    Cell: ({ cell }) => {
      return formatToMoscowTZ(cell.getValue<string>())
    },
  },
]

const RpPayoutsTable: FC = observer(() => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 10 })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { drawerCRUDStore } = useStore()

  const { data, isError, isFetching, isLoading } = useQuery(
    [EQueryKeysConstant.RP_PAYOUTS, pagination.pageIndex, pagination.pageSize],
    () =>
      Prp2boxApiPayouts.getAll({
        limit: pagination.pageSize,
        offset: pagination.pageIndex * pagination.pageSize,
      }),
    {
      refetchOnWindowFocus: false,
      onError: (err) => toast.error(`${err}`),
      enabled: true,
      keepPreviousData: true,
    }
  )

  const table = useMaterialReactTable({
    ...mrtLocalization,
    enableGlobalFilter: false,
    data: data?.rows || [],
    columns,
    rowCount: data?.totalRows || 0,
    state: {
      pagination,
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isFetching,
    },
    manualPagination: true,
    onPaginationChange: setPagination,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        event.preventDefault()
        event.stopPropagation()
        drawerCRUDStore.changeView(EDrawerView.RP_PAYOUTS_EDIT, String(row.original.id))
      },
      sx: {
        cursor: 'pointer',
      },
    }),
    renderTopToolbarCustomActions: () => {
      return (
        <Button
          variant="contained"
          onClick={() => {
            drawerCRUDStore.changeView(EDrawerView.RP_PAYOUTS_CREATE)
          }}>
          Создать новую выплату
        </Button>
      )
    },
  })

  return <MaterialReactTable table={table} />
})

export default RpPayoutsTable
